<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9.5" stroke="#000" stroke-width="1.5"/>
    <path d="M11.5 6.5V13.5H16.5" stroke="#000" stroke-width="1.5"/>
</svg>
